// src/firebase.js

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// 1. Initialize Firebase app first!
const firebaseConfig = {
  apiKey: "AIzaSyD1QH8AGTtMJ2z1AI4UpylFhZRSVxE4SWE",
  authDomain: "tufftimer.firebaseapp.com",
  projectId: "tufftimer",
  storageBucket: "tufftimer.appspot.com",
  messagingSenderId: "891895907593",
  appId: "1:891895907593:web:e6cedf62505c347d673fd8",
  measurementId: "G-0CECG6D8V4"
};

export const app = initializeApp(firebaseConfig);   
export const db = getFirestore(app);
export const auth = getAuth(app);                    
